import { Injectable } from '@angular/core';
import { Question } from "../models/question";
import { ChecklistQuestion } from "../models/checklist-question";
import { MultipleChoiceQuestion } from "../models/multiple-choice-question";
import { TextboxQuestion } from "../models/textbox-question";
import { QuestionType } from "../models/question-type";
import {SingleChoiceQuestion} from "../models/single-choice-question";

@Injectable()
export class QuestionFactoryService {

  constructor() { }

  public createQuestionForType(type:QuestionType) : Question {
    if (type == QuestionType.Textbox) {
      return new TextboxQuestion();
    }
    else if (type == QuestionType.Checklist) {
      return new ChecklistQuestion();
    }
    else if (type == QuestionType.SingleChoice) {
      return new SingleChoiceQuestion();
    }
    return new MultipleChoiceQuestion();
  }

  public createDefaultEmptyQuestion() {
    // create an empty multiple choice question.
    return this.createQuestionForType(QuestionType.MultipleChoice);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/question-factory.service.ts